import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type ModulePoliciesDetachConfirmationModalProps = {
  onConfirm: () => void;
  name: string;
};

const ModulePoliciesDetachConfirmationModal = create(
  function ModulePoliciesDetachConfirmationModal({
    onConfirm,
    name,
  }: ModulePoliciesDetachConfirmationModalProps) {
    const modal = useModal();

    const handleOnConfirm = () => {
      modal.resolve();
      modal.hide();
      onConfirm();
    };

    return (
      <ConfirmationModal
        title="Detach policy"
        confirmationButtonLabel="Detach"
        confirmationButtonVariant="dangerPrimary"
        onConfirm={handleOnConfirm}
      >
        <ConfirmationModalMessage>
          Are you sure you want to detach <strong>{name}</strong> policy?
        </ConfirmationModalMessage>
      </ConfirmationModal>
    );
  }
);

export const showModulePoliciesDetachConfirmationModal = (
  props: ModulePoliciesDetachConfirmationModalProps
) => show(ModulePoliciesDetachConfirmationModal, props);
